import { createContext, useContext } from "react";

import type { DropdownInternals } from "../types";

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const DropdownContext = createContext<DropdownInternals | null>(null);

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const useDropdownContext = (): DropdownInternals =>
  useContext(DropdownContext) as DropdownInternals;

export { useDropdownContext, DropdownContext };
